import React, { Component } from "react";
import BreadcrumbCustomer from "../breadcrumb";
import {  Form, Upload,  Button,message, Divider,Typography,Select, Empty,Descriptions} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import {importFinance} from "../../model/loan/requests"
import { PermanentlyLock, ClearActivationDate } from '../../model/device/requests';

import storage from '../../utils/storage';
import { configs } from '../../config/config';
export const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
};

export const tailLayout = {
    wrapperCol: {
      offset: 8,
      span: 16,
    },
};

const {  Paragraph} = Typography;
const Option = Select.Option;

class ClearActivation extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            visiable: true,
            fileList: [],
            unActivationList:"",
        }
    };
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }

    beforeUpload = (file) => {
        this.setState({
            unActivationList:""
        })
        if ( file.name.indexOf('.csv') === -1 ) {
            message.error('you can only upload "CSV" format file ')
        }
        return false;

    };
    
    onChangeEvent = (info)=>{

        if ( info.file.name.indexOf('.csv') !== -1 ) {
            let fileList = [...info.fileList];
            fileList = fileList.slice(-1);
        //   console.log(fileList.length)
            if (fileList.length === 1) {
                this.setState({
                    visiable:false
                })
            }
            this.setState({ fileList })
        }
    }
    onRemoveEvent = (file)=>{
        const { fileList } = this.state;
        const index = fileList.indexOf(file);
        let newFileList = fileList.slice();
        newFileList.splice(index, 1);
        if (newFileList.length < 1) {
            this.setState({
                visiable: true
            })
        }
        this.setState({
            fileList: newFileList
        })
    };

    handlerSubmit = (e) => {
        const { fileList } = this.state;
        const formData = new FormData();
        fileList.forEach(file => {
            formData.append('file', file.originFileObj);
        });
        PermanentlyLock(formData).then(res=>{
           if(res.data.code === 200){
                message.success("permanently lock upload success")
                this.setState({
                    fileList:[],
                    visiable:true
                })
           }else{
               message.error("Upload Failed")
           }
        }).catch(err=>{
            message.error(err)
        })
    
    }


    handlerUpload = (e) => {

        const { fileList } = this.state;
        const formData = new FormData();
        fileList.forEach(file => {
            formData.append('file', file.originFileObj);
        });
       ClearActivationDate(formData).then(res=>{
        if(res.data.code === 200){
            message.success("upload success")
            this.setState({
                fileList:[],
            })
            // if data.data is not empty means that there are some devices not found in the db
            if(res.data.data.length > 0){
                let ret = res.data.data.join(";")
                this.setState({
                    unActivationList : ret
                })
            }
       }else{
           message.error("Upload Failed")
       }
       }).catch(err=>{
        message.error(err)
       })
    }

    handlerChange = (item) => {
        // we just need the first one
        let zone = item.split(",")[0]
        this.setState({
            zone:zone
        })
        
    }

    render() {
        const { visiable,unActivationList} = this.state;
     
        return (
            <>
                <BreadcrumbCustomer first='Clear Activation' />

                <Divider />
                <Form
                    {...layout}
                    ref={this.formRef}
                >
                    <Form.Item
                            label="Upload"
                        >
                            <Upload 
                                      name = 'filename'
                                      showPreviewIcon
                                      fileList = {this.state.fileList}
                                      onChange={this.onChangeEvent}
                                      onRemove = {this.onRemoveEvent}
                                      beforeUpload={this.beforeUpload}
                                      multiple={false}
                            >
                            <Button icon={<UploadOutlined />}>Click to upload</Button>
                            </Upload>
                        </Form.Item>
                        <Form.Item
                            wrapperCol={{
                                span: 12,
                                offset: 6,
                              }}
                        >
                            <Button type="primary" 
                                onClick = {this.handlerUpload}
                                disabled = {visiable}
                                style={{background: "#851dd6",color:"white" }}
                                
                            >
                              Clear Activation
                            </Button>

                            <Button type="primary" 
                                onClick = {this.handlerSubmit}
                                disabled = {visiable}
                                danger
             
                                
                            >
                                Permanently Lock
                            </Button>
                        </Form.Item>    
                </Form>  
                <Divider />

                {unActivationList.length >0 ? (
                    <Descriptions bordered title=""> 
                    <Descriptions.Item label="No UnActivation Device"> 
                    {unActivationList}
                    </Descriptions.Item>
                    </Descriptions>
                 ) : (
                    <Empty />
                 )}

            
            </>
        );
    }
}

export default ClearActivation ;